/**
 * 账务总计
 */
import React, { useContext, useEffect } from 'react';
import intl from 'react-intl-universal';

import { parseFen2Yuan } from '@/utils/number';
import { getCdnHost } from '@/config/apiHosts';

import { DrawerContext, HandoverInfo } from '@/pages/handover/helper';

import IndicatorList from '../IndicatorList';
import BillChannelTable from '../BillChannelTable';

interface IProps {
  handoverInfo: HandoverInfo;
}

const Index: React.FC<IProps> = (props) => {
  const { getHandoverInfo } = useContext(DrawerContext);
  const { handoverInfo } = props;

  const indicatorList = [
    {
      name: intl.get('handover_indicator_last_petty'),
      label: intl.get('handover_indicator_last_petty'),
      icon: `${getCdnHost()}/image/common/20230403/165810147-rest_reverse.png`,
      content: parseFen2Yuan(handoverInfo.lastPettyCash),
    },
    {
      name: intl.get('handover_indicator_next_petty'),
      label: intl.get('handover_indicator_next_petty'),
      icon: `${getCdnHost()}/image/common/20230403/165810154-reverse.png`,
      content: parseFen2Yuan(handoverInfo.nextPettyCash),
    },
    {
      name: intl.get('handover_indicator_hand_in_petty'),
      label: intl.get('handover_indicator_hand_in_petty'),
      icon: `${getCdnHost()}/image/common/20230403/165810088-cash.png`,
      iconHeight: 42,
      content: parseFen2Yuan(handoverInfo.handInPettyCash),
    },
  ];

  useEffect(() => {
    getHandoverInfo();
  }, []);

  return (
    <div>
      <IndicatorList items={indicatorList} />
      <BillChannelTable dataSource={handoverInfo.shiftHandoverVOList} />
    </div>
  );
};

export default Index;
